<template>
  <div class="racePassword">
    <div class="container">
      <h1 class="title">请输入比赛密码</h1>

      <div class="inputZone" v-show="!isInputPassError">
        <h4>请向工作人员获取比赛密码，正确输入后即可进入比赛。</h4>

        <div class="part">
          <el-input
            v-model.trim="password"
            placeholder="密码为6位数字组成"
            style="width:70%; margin: 0 15%;"
            clearable
          />
        </div>
      </div>

      <div class="errorZone" v-show="isInputPassError">
        <h4>您输入的比赛密码不正确，请重新输入。</h4>
      </div>

      <div class="part btnZone">
        <i class="btnCancel" @click="cancelHandler()"></i>
        <i
          v-show="!isInputPassError"
          class="btnConfirm"
          @click="confirmHandler()"
        />
        <i
          v-show="isInputPassError"
          class="btnReInput"
          @click="reInputHandler()"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      isInputPassError: false,
    };
  },

  methods: {
    
    cancelHandler() {
      this.$emit("onCancel");
    },
    confirmHandler() {
      this.$emit("onConfirm", this.password);
    },
    reInputHandler() {
      this.$emit("onReInput");
    },
    setReInput(val) {
      this.isInputPassError = val;
    },
    setCancel() {
      this.password = "";
      this.$parent.RacePasswordShow = false;
      this.isInputPassError = false;
    },
    setPassword(val) {
      this.password = val;
    }
  },
};
</script>

<style lang="scss">
.racePassword {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2333;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 650px;
    height: 339px;
    background: url("../../assets/images/racePassword_bg.png") center / contain
      no-repeat;
    color: #0ff;
    text-align: center;
    transform: translate(-50%, -50%);

    .title {
      margin: 40px 0 10px 0;
    }

    > .part {
      width: 100%;
    }

    .el-input {
      .el-input__inner {
        background-color: transparent;
        border: 2px solid #0ff;
        color: #fff;
        font-size: 18px;
        font-weight: bold;

        &::placeholder {
          color: #0ff;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }

    .inputZone {
      h4 {
        padding: 20px 0 30px;
      }
    }
    .errorZone {
      h4 {
        padding: 50px 0 40px;
      }
    }

    .btnZone {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 30px;

      i {
        width: 165px;
        height: 52px;
        cursor: pointer;
      }
    }

    .btnCancel {
      background: url("../../assets/images/racePassword_cancel.png") center /
        contain no-repeat;
    }
    .btnConfirm {
      background: url("../../assets/images/racePassword_confirm.png") center /
        contain no-repeat;
    }
    .btnReInput {
      background: url("../../assets/images/racePassword_reInput.png") center /
        contain no-repeat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/racePassword.vue